import React, { HTMLAttributes, ImgHTMLAttributes, useState } from 'react';
import Icon from '../../muiComponents/Icon';
import '../../stylesheets/stylesComponents/image-component.scss';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    useLocalBaseUrl?: boolean;
    placeholder?: string;
    placeholderProps?: HTMLAttributes<HTMLDivElement>;
}

const Image = (props: ImageProps) => {
    const {
        src,
        useLocalBaseUrl = true,
        style,
        placeholder = 'Image',
        className,
        placeholderProps,
        ...restProps
    } = props;

    const { className: placeholderClassName = '', ...restPlaceholderProps } =
        placeholderProps || {};
    const baseUrl = useLocalBaseUrl ? process.env.REACT_APP_IMAGE_BASE_URL : '';

    const imgSrc = src ? `${baseUrl}${src}` : undefined;
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleError = () => {
        setHasError(true);
        setIsLoaded(true);
    };

    const handleLoad = () => {
        setIsLoaded(true);
    };

    const showPlaceholder = !isLoaded || hasError;

    return (
        <>
            {showPlaceholder && (
                <div
                    className={`image-placeholder ${className} ${placeholderClassName}`}
                    {...restPlaceholderProps}
                >
                    <Icon iconName={placeholder} style={{ fontSize: '2rem' }} />
                </div>
            )}

            <img
                src={imgSrc}
                onLoad={handleLoad}
                onError={handleError}
                style={{
                    display: showPlaceholder ? 'none' : 'block',
                    ...style,
                }}
                className={className}
                {...restProps}
            />
        </>
    );
};

export default Image;
